import { render } from "./summary.vue?vue&type=template&id=60914e78&ts=true"
import script from "./summary.vue?vue&type=script&lang=ts"
export * from "./summary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__